import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../styles/NavBar.css";
import logo from "../assets/AMF-Logo-no-background.png";
import { FaBars, FaTimes } from "react-icons/fa";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const handleServicesClick = () => {
    setMenuOpen(false);
    navigate("/");
    setTimeout(() => {
      const section = document.getElementById("services");
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  const handleQuoteClick = () => {
    setMenuOpen(false);
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const section = document.getElementById("quote");
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      const section = document.getElementById("quote");
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">

        <div className="logo-section">
          <img src={logo} alt="AMF Movers Logo" className="logo" />

          <div className="mobile-tagline">
            <p className="tagline-main">We pick, pack & deliver</p>
            <p className="tagline-sub">Faster. Safer. Convenient.</p>
          </div>
        </div>

        {/* Hamburger */}
        <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>

        <ul className={menuOpen ? "nav-links active" : "nav-links"}>
          <li><Link to="/" className="nav-link" onClick={() => setMenuOpen(false)}>Home</Link></li>
          <li><Link to="/" className="nav-link" onClick={handleServicesClick}>Services</Link></li>
          <li><Link to="/about" className="nav-link" onClick={() => setMenuOpen(false)}>About</Link></li>
          <li><Link to="/gallery" className="nav-link" onClick={() => setMenuOpen(false)}>Gallery</Link></li>
          <li><Link to="/contact" className="nav-link" onClick={() => setMenuOpen(false)}>Contact</Link></li>

          {/* Move button inside menu for mobile */}
          <li className="mobile-quote">
            <button className="quote-btn" onClick={handleQuoteClick}>Get a Quote</button>
          </li>
        </ul>

        {/* Desktop button */}
        <button className="quote-btn desktop-only" onClick={handleQuoteClick}>
          Get a Quote
        </button>

      </div>
    </nav>
  );
}

export default Navbar;